import { ThemeUIStyleObject } from 'theme-ui';

export const formContainerStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 30,
};

export const sectionStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
};

export const labelStyles: ThemeUIStyleObject = {
  marginBottom: 1,
};

export const dropZoneStyles = (isDragging: boolean, hasError: boolean): ThemeUIStyleObject => ({
  border: '2px dashed',
  borderColor: isDragging ? 'primary' : hasError ? 'error' : 'neutral/300',
  borderRadius: 'medium',
  padding: 4,
  textAlign: 'center',
  backgroundColor: isDragging ? 'primary/10' : 'neutral/50',
  cursor: 'pointer',
  transition: 'all 0.2s',
  minHeight: '150px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    borderColor: 'primary',
    backgroundColor: 'primary/5',
  },
});

export const fileInfoStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const errorTextStyles: ThemeUIStyleObject = {
  marginTop: 1,
  color: 'error',
};

export const instructionsBoxStyles: ThemeUIStyleObject = {
  padding: 5,
  backgroundColor: 'info/10',
  borderRadius: 'medium',
  borderLeft: '4px solid',
  borderLeftColor: 'info',
};

export const instructionsTitleStyles: ThemeUIStyleObject = {
  marginBottom: 2,
};

export const instructionsListStyles: ThemeUIStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  color: 'neutral/700',
};
